<script setup>
import helpers from "../helpers/index.js"
defineProps({
  data: Object,
  items: Object,
})
let isMobile = helpers.isMobile()
let isTrack = location.hash.includes("/track")

</script>

<template>
  <header class="mx-auto flex flex-row mb-[30px] lg:flex-wrap">

    <h1 v-if="!isMobile && isTrack"
        class="text-tc-black text-tc-title font-minionpro font-medium lg:w-full lg:mb-[30px]"
        v-text="'Resolve Center'"
    ></h1>

    <div class="relative mr-4 z-1"
         :class="{ 'w-[60px] h-[60px]' : items?.length > 1, 'w-[50px] h-[50px]': items?.length === 1 }">
        <span v-if="items?.length === data.items?.length" v-text="items?.length"
            class="absolute bg-black rounded-full text-white text-tc-md h-[16px] w-[16px] flex justify-center items-center z-4 -top-1.5 -right-1.5"></span>
      <img :src="items[0]?.image" class="w-[50px] shadow z-3 absolute top-0 right-0" alt="image" />
      <img v-if="items?.length > 1" :src="items[1]?.image ?? items[0]?.image"
           class="w-[50px] shadow z-2 absolute top-2 right-2" alt="image"/>
      <img v-if="items?.length > 2" :src="items[2]?.image ?? items[0]?.image"
           class="w-[50px] shadow z-1 absolute top-4 right-4" alt="image"/>
    </div>

    <div class="flex flex-col justify-center">
        <span class="block w-10/12 text-tc-xl font-avenir"
              v-text="items?.length === 1 ? items[0]?.name : (data?.items?.length === items?.length ? 'All Items' : `${items?.length} Items`)"></span>
      <p class="text-tc-muted-brown text-tc-xl font-avenir" v-text="`(If the issue is the same)`" v-if="items?.length > 1"></p>
    </div>

  </header>
</template>

<style scoped></style>
